import { z } from "zod";

/**
 * @name 목표관리 Detail Type 타입
 * LAST_WEEK_ACTION_REPORT, THIS_WEEK_ACTION_PLAN, MONTHLY_ACTION_PLAN, YEARLY_ACTION_PLAN, FIRST_HALF_ACTION_PLAN, SECOND_HALF_ACTION_PLAN
 */
export const SALES_DETAIL_TYPE_KEY_TYPE_ENUM = [
	"LAST_WEEK_ACTION_REPORT",
	"THIS_WEEK_ACTION_PLAN",
	"MONTHLY_ACTION_PLAN",
	"YEARLY_ACTION_PLAN",
	"FIRST_HALF_ACTION_PLAN",
	"SECOND_HALF_ACTION_PLAN"
] as const;
export const SALES_DETAIL_TYPE_KEY_TYPE = z.enum(SALES_DETAIL_TYPE_KEY_TYPE_ENUM);
export type SALES_DETAIL_TYPE_KEY_TYPE = z.infer<typeof SALES_DETAIL_TYPE_KEY_TYPE>;

export const SALES_DETAIL_TYPE_VALUE_TYPE_ENUM = [
	"지난주 활동 결과",
	"이번주 활동계획",
	"월간 활동계획",
	"연간 활동계획",
	"상반기 활동계획",
	"하반기 활동계획"
] as const;
export const SALES_DETAIL_TYPE_VALUE_TYPE = z.enum(SALES_DETAIL_TYPE_VALUE_TYPE_ENUM);
export type SALES_DETAIL_TYPE_VALUE_TYPE = z.infer<typeof SALES_DETAIL_TYPE_VALUE_TYPE>;

export const SALES_DETAIL_TYPE: Record<SALES_DETAIL_TYPE_KEY_TYPE, SALES_DETAIL_TYPE_VALUE_TYPE> = {
	LAST_WEEK_ACTION_REPORT: "지난주 활동 결과",
	THIS_WEEK_ACTION_PLAN: "이번주 활동계획",
	MONTHLY_ACTION_PLAN: "월간 활동계획",
	YEARLY_ACTION_PLAN: "연간 활동계획",
	FIRST_HALF_ACTION_PLAN: "상반기 활동계획",
	SECOND_HALF_ACTION_PLAN: "하반기 활동계획"
} as const;

/**
 * @name 목표관리 Status 타입
 * DEFAULT, APPROVAL_PENDING, APPROVED, REJECTED, REAPPROVAL_PENDING
 */
export const SALES_STATUS_KEY_TYPE_ENUM = [
	"DEFAULT",
	"APPROVAL_PENDING",
	"APPROVED",
	"REJECTED",
	"REAPPROVAL_PENDING"
] as const;
export const SALES_STATUS_KEY_TYPE = z.enum(SALES_STATUS_KEY_TYPE_ENUM);
export type SALES_STATUS_KEY_TYPE = z.infer<typeof SALES_STATUS_KEY_TYPE>;

export const SALES_STATUS_VALUE_TYPE_ENUM = ["기본", "승인 대기", "승인", "반려", "재승인 대기"] as const;
export const SALES_STATUS_VALUE_TYPE = z.enum(SALES_STATUS_VALUE_TYPE_ENUM);
export type SALES_STATUS_VALUE_TYPE = z.infer<typeof SALES_STATUS_VALUE_TYPE>;

export const SALES_STATUS: Record<SALES_STATUS_KEY_TYPE, SALES_STATUS_VALUE_TYPE> = {
	DEFAULT: "기본",
	APPROVAL_PENDING: "승인 대기",
	APPROVED: "승인",
	REJECTED: "반려",
	REAPPROVAL_PENDING: "재승인 대기"
} as const;

/**
 * @name 목표관리 Target 타입
 */
export const SALES_TARGET_KEY_TYPE_ENUM = ["PERSONAL", "DEPARTMENT", "SALES_DEPARTMENT_ALL"] as const;
export const SALES_TARGET_KEY_TYPE = z.enum(SALES_TARGET_KEY_TYPE_ENUM);
export type SALES_TARGET_KEY_TYPE = z.infer<typeof SALES_TARGET_KEY_TYPE>;

/**
 * @name PERIOD 타입
 */
export const PERIOD_KEY_TYPE_ENUM = ["YEARLY", "MONTHLY", "WEEKLY"] as const;
export const PERIOD_KEY_TYPE = z.enum(PERIOD_KEY_TYPE_ENUM);
export type PERIOD_KEY_TYPE = z.infer<typeof PERIOD_KEY_TYPE>;

export const PERIOD_VALUE_TYPE_ENUM = ["연", "월", "주"] as const;
export const PERIOD_VALUE_TYPE = z.enum(PERIOD_VALUE_TYPE_ENUM);
export type PERIOD_VALUE_TYPE = z.infer<typeof PERIOD_VALUE_TYPE>;

export const PERIOD: Record<PERIOD_KEY_TYPE, PERIOD_VALUE_TYPE> = {
	YEARLY: "연",
	MONTHLY: "월",
	WEEKLY: "주"
} as const;

/**
 * @name REQUEST_TYPE 타입
 */
export const REQUEST_TYPE_KEY_TYPE_ENUM = ["INSERT", "UPDATE"] as const;
export const REQUEST_TYPE_KEY_TYPE = z.enum(REQUEST_TYPE_KEY_TYPE_ENUM);
export type REQUEST_TYPE_KEY_TYPE = z.infer<typeof REQUEST_TYPE_KEY_TYPE>;

export const REQUEST_TYPE_VALUE_TYPE_ENUM = ["등록", "수정"] as const;
export const REQUEST_TYPE_VALUE_TYPE = z.enum(REQUEST_TYPE_VALUE_TYPE_ENUM);
export type REQUEST_TYPE_VALUE_TYPE = z.infer<typeof REQUEST_TYPE_VALUE_TYPE>;

export const REQUEST_TYPE: Record<REQUEST_TYPE_KEY_TYPE, REQUEST_TYPE_VALUE_TYPE> = {
	INSERT: "등록",
	UPDATE: "수정"
} as const;

/**
 * @name REQUEST_STATUS 타입
 */
export const REQUEST_STATUS_KEY_TYPE_ENUM = ["PENDING", "APPROVED", "REJECTED"] as const;
export const REQUEST_STATUS_KEY_TYPE = z.enum(REQUEST_STATUS_KEY_TYPE_ENUM);
export type REQUEST_STATUS_KEY_TYPE = z.infer<typeof REQUEST_STATUS_KEY_TYPE>;

export const REQUEST_STATUS_VALUE_TYPE_ENUM = ["대기", "승인", "거절"] as const;
export const REQUEST_STATUS_VALUE_TYPE = z.enum(REQUEST_STATUS_VALUE_TYPE_ENUM);
export type REQUEST_STATUS_VALUE_TYPE = z.infer<typeof REQUEST_STATUS_VALUE_TYPE>;

export const REQUEST_STATUS: Record<REQUEST_STATUS_KEY_TYPE, REQUEST_STATUS_VALUE_TYPE> = {
	PENDING: "대기",
	APPROVED: "승인",
	REJECTED: "거절"
} as const;

/**
 * @name LOB 타입
 * LIFE_INSURANCE("생명보험"), LONG_TERM_INSURANCE("장기손해보험"), NORMAL_INSURANCE("일반보험"), CAR_INSURANCE("자동차보험"), ETC("기타"),  UNKNOWN("알수없음")
 */
export const LOB_KEY_TYPE_ENUM = [
	"LIFE_INSURANCE",
	"LONG_TERM_INSURANCE",
	"NORMAL_INSURANCE",
	"CAR_INSURANCE",
	"ETC",
	"UNKNOWN"
] as const;
export const LOB_KEY_TYPE = z.enum(LOB_KEY_TYPE_ENUM);
export type LOB_KEY_TYPE = z.infer<typeof LOB_KEY_TYPE>;

export const LOB_VALUE_TYPE_ENUM = ["생명보험", "장기손해보험", "일반보험", "자동차보험", "기타", "알수없음"] as const;
export const LOB_VALUE_TYPE = z.enum(LOB_VALUE_TYPE_ENUM);
export type LOB_VALUE_TYPE = z.infer<typeof LOB_VALUE_TYPE>;

export const LOB: Record<LOB_KEY_TYPE, LOB_VALUE_TYPE> = {
	LIFE_INSURANCE: "생명보험",
	LONG_TERM_INSURANCE: "장기손해보험",
	NORMAL_INSURANCE: "일반보험",
	CAR_INSURANCE: "자동차보험",
	ETC: "기타",
	UNKNOWN: "알수없음"
} as const;

/**
 * @name 영업현황 타입
 * "SETTLEMENT_FEE" | "NORMAL_INSURANCE" | "TAX_ACCOUNTANT_REGISTRATION"
 */
export const QUALIFICATION_KEY_TYPE_ENUM = [
	"SETTLEMENT_FEE",
	"NORMAL_INSURANCE",
	"TAX_ACCOUNTANT_REGISTRATION",
	"MANAGER_RECRUITING"
] as const;
export const QUALIFICATION_KEY_TYPE = z.enum(QUALIFICATION_KEY_TYPE_ENUM);
export type QUALIFICATION_KEY_TYPE = z.infer<typeof QUALIFICATION_KEY_TYPE>;

export const QUALIFICATION_VALUE_TYPE_ENUM = ["정산P", "일반보험", "세무사 등록", "팀원증원"] as const;
export const QUALIFICATION_VALUE_TYPE = z.enum(QUALIFICATION_VALUE_TYPE_ENUM);
export type QUALIFICATION_VALUE_TYPE = z.infer<typeof QUALIFICATION_VALUE_TYPE>;

export const QUALIFICATION: Record<QUALIFICATION_KEY_TYPE, QUALIFICATION_VALUE_TYPE> = {
	SETTLEMENT_FEE: "정산P",
	NORMAL_INSURANCE: "일반보험",
	TAX_ACCOUNTANT_REGISTRATION: "세무사 등록",
	MANAGER_RECRUITING: "팀원증원"
} as const;

/**
 * @name 학력 타입
 * HIGH_SCHOOL, UNIVERSITY, GRADUATE_SCHOOL
 */
export const EDUCATION_KEY_TYPE_ENUM = ["HIGH_SCHOOL", "UNIVERSITY", "GRADUATE_SCHOOL"] as const;
export const EDUCATION_KEY_TYPE = z.enum(EDUCATION_KEY_TYPE_ENUM);
export type EDUCATION_KEY_TYPE = z.infer<typeof EDUCATION_KEY_TYPE>;

export const EDUCATION_VALUE_TYPE_ENUM = ["고등학교", "대학교", "대학원"] as const;
export const EDUCATION_VALUE_TYPE = z.enum(EDUCATION_VALUE_TYPE_ENUM);
export type EDUCATION_VALUE_TYPE = z.infer<typeof EDUCATION_VALUE_TYPE>;

export const EDUCATION: Record<EDUCATION_KEY_TYPE, EDUCATION_VALUE_TYPE> = {
	HIGH_SCHOOL: "고등학교",
	UNIVERSITY: "대학교",
	GRADUATE_SCHOOL: "대학원"
} as const;

/**
 * @name 운영 형태
 * PERSONAL(개인), REGISTERED_CORPORATION(법인(등록)), UNREGISTERED_CORPORATION(법인(미등록)), TAX_CORPORATION(세무법인), LAW_FIRM(법무법인), ETC(기타), UNKNOWN(알수없음)
 */
export const CORPORATION_OPERATION_KEY_TYPE_ENUM = [
	"PERSONAL",
	"CORPORATION",
	"TAX_CORPORATION",
	"LAW_FIRM",
	"ETC",
	"UNKNOWN"
] as const;
export const CORPORATION_OPERATION_KEY_TYPE = z.enum(CORPORATION_OPERATION_KEY_TYPE_ENUM);
export type CORPORATION_OPERATION_KEY_TYPE = z.infer<typeof CORPORATION_OPERATION_KEY_TYPE>;

export const CORPORATION_OPERATION_VALUE_TYPE_ENUM = [
	"개인",
	"법인",
	"세무법인",
	"법무법인",
	"기타",
	"알수없음"
] as const;
export const CORPORATION_OPERATION_VALUE_TYPE = z.enum(CORPORATION_OPERATION_VALUE_TYPE_ENUM);
export type CORPORATION_OPERATION_VALUE_TYPE = z.infer<typeof CORPORATION_OPERATION_VALUE_TYPE>;

export const CORPORATION_OPERATION: Record<CORPORATION_OPERATION_KEY_TYPE, CORPORATION_OPERATION_VALUE_TYPE> = {
	PERSONAL: "개인",
	CORPORATION: "법인",
	TAX_CORPORATION: "세무법인",
	LAW_FIRM: "법무법인",
	ETC: "기타",
	UNKNOWN: "알수없음"
} as const;

/**
 * @name 세무사 타입(개인, 법인)
 * PERSONAL(개인), CORPORATION(법인)
 */
export const CORPORATION_KEY_TYPE_ENUM = ["PERSONAL", "CORPORATION", "NONE"] as const;
export const CORPORATION_KEY_TYPE = z.enum(CORPORATION_KEY_TYPE_ENUM);
export type CORPORATION_KEY_TYPE = z.infer<typeof CORPORATION_KEY_TYPE>;

export const CORPORATION_VALUE_TYPE_ENUM = ["개인", "법인", "-"] as const;
export const CORPORATION_VALUE_TYPE = z.enum(CORPORATION_VALUE_TYPE_ENUM);
export type CORPORATION_VALUE_TYPE = z.infer<typeof CORPORATION_VALUE_TYPE>;

export const CORPORATION: Record<CORPORATION_KEY_TYPE, CORPORATION_VALUE_TYPE> = {
	PERSONAL: "개인",
	CORPORATION: "법인",
	NONE: "-"
} as const;

/**
 * @name 현황(개업, 휴업, 미등록, 폐업, 탈퇴, 알수없음)
 * OPENED(개업), SUSPENDED(휴업), UNREGISTERED(미등록), CLOSED(폐업), WITHDRAWN(탈퇴), UNKNOWN(알수없음), APPROVED(승인완료), APPROVE_PENDING(승인대기)
 */
export const STATUS_KEY_TYPE_ENUM = ["OPENED", "SUSPENDED", "UNREGISTERED", "CLOSED", "WITHDRAWN", "UNKNOWN"] as const;
export const STATUS_KEY_TYPE = z.enum(STATUS_KEY_TYPE_ENUM);
export type STATUS_KEY_TYPE = z.infer<typeof STATUS_KEY_TYPE>;

export const STATUS_VALUE_TYPE_ENUM = ["개업", "휴업", "미등록", "폐업", "탈퇴", "알수없음"] as const;
export const STATUS_VALUE_TYPE = z.enum(STATUS_VALUE_TYPE_ENUM);
export type STATUS_VALUE_TYPE = z.infer<typeof STATUS_VALUE_TYPE>;

export const STATUS: Record<STATUS_KEY_TYPE, STATUS_VALUE_TYPE> = {
	OPENED: "개업",
	SUSPENDED: "휴업",
	UNREGISTERED: "미등록",
	CLOSED: "폐업",
	WITHDRAWN: "탈퇴",
	UNKNOWN: "알수없음"
} as const;

/**
 * @name 기간(월간, 분기간, 반기간, 연간)
 */
export const DURATION_KEY_TYPE_ENUM = ["MONTH", "QUARTER", "HALF_YEAR", "YEAR"] as const;
export const DURATION_KEY_TYPE = z.enum(DURATION_KEY_TYPE_ENUM);
export type DURATION_KEY_TYPE = z.infer<typeof DURATION_KEY_TYPE>;

export const DURATION_VALUE_TYPE_ENUM = ["월간", "분기간", "반기간", "연간"] as const;
export const DURATION_VALUE_TYPE = z.enum(DURATION_VALUE_TYPE_ENUM);
export type DURATION_VALUE_TYPE = z.infer<typeof DURATION_VALUE_TYPE>;

export const DURATION: Record<DURATION_KEY_TYPE, DURATION_VALUE_TYPE> = {
	MONTH: "월간",
	QUARTER: "분기간",
	HALF_YEAR: "반기간",
	YEAR: "연간"
} as const;

/**
 * @name 날짜 기간(일, 주, 월)
 */
export const DATE_DURATION_KEY_TYPE_ENUM = ["DAY", "WEEK", "MONTH", "CUSTOM"] as const;
export const DATE_DURATION_KEY_TYPE = z.enum(DATE_DURATION_KEY_TYPE_ENUM);
export type DATE_DURATION_KEY_TYPE = z.infer<typeof DATE_DURATION_KEY_TYPE>;

export const DATE_DURATION_VALUE_ENUM = ["일", "주", "월", "직접입력"] as const;
export const DATE_DURATION_VALUE_TYPE = z.enum(DATE_DURATION_VALUE_ENUM);
export type DATE_DURATION_VALUE_TYPE = z.infer<typeof DATE_DURATION_VALUE_TYPE>;

export const DATE_DURATION: Record<DATE_DURATION_KEY_TYPE, DATE_DURATION_VALUE_TYPE> = {
	DAY: "일",
	WEEK: "주",
	MONTH: "월",
	CUSTOM: "직접입력"
} as const;

/**
 * @name 개업여부(개업, 폐업, 미등록)
 * OPENED, SUSPENDED, UNREGISTERED, CLOSED, WITHDRAWN, UNKNOWN
 */
export const OPENING_KEY_TYPE_ENUM = ["OPENED", "CLOSED", "UNREGISTERED", "SUSPENDED", "WITHDRAWN", "UNKNOWN"] as const;
export const OPENING_KEY_TYPE = z.enum(OPENING_KEY_TYPE_ENUM);
export type OPENING_KEY_TYPE = z.infer<typeof OPENING_KEY_TYPE>;

export const OPENING_VALUE_TYPE_ENUM = ["개업", "폐업", "미등록", "휴업", "탈퇴", "알수없음"] as const;
export const OPENING_VALUE_TYPE = z.enum(OPENING_VALUE_TYPE_ENUM);
export type OPENING_VALUE_TYPE = z.infer<typeof OPENING_VALUE_TYPE>;

export const OPENING: Record<OPENING_KEY_TYPE, OPENING_VALUE_TYPE> = {
	OPENED: "개업",
	CLOSED: "폐업",
	UNREGISTERED: "미등록",
	SUSPENDED: "휴업",
	WITHDRAWN: "탈퇴",
	UNKNOWN: "알수없음"
} as const;

/**
 * @name 결혼여부(미혼, 기혼)
 */
export const MARITAL_STATUS_KEY_TYPE_ENUM = ["UNKNOWN", "SINGLE", "MARRIED", "DIVORCED", "WIDOWED"] as const;
export const MARITAL_STATUS_KEY_TYPE = z.enum(MARITAL_STATUS_KEY_TYPE_ENUM);
export type MARITAL_STATUS_KEY_TYPE = z.infer<typeof MARITAL_STATUS_KEY_TYPE>;

export const MARITAL_STATUS_VALUE_TYPE_ENUM = ["알수없음", "미혼", "기혼", "이혼", "사별"] as const;
export const MARITAL_STATUS_VALUE_TYPE = z.enum(MARITAL_STATUS_VALUE_TYPE_ENUM);
export type MARITAL_STATUS_VALUE_TYPE = z.infer<typeof MARITAL_STATUS_VALUE_TYPE>;

export const MARITAL_STATUS: Record<MARITAL_STATUS_KEY_TYPE, MARITAL_STATUS_VALUE_TYPE> = {
	UNKNOWN: "알수없음",
	SINGLE: "미혼",
	MARRIED: "기혼",
	DIVORCED: "이혼",
	WIDOWED: "사별"
} as const;

/**
 * @name 가족관계
 * SPOUSE, CHILD
 */
export const RELATIONSHIP_KEY_TYPE_ENUM = ["SPOUSE", "CHILD"] as const;
export const RELATIONSHIP_KEY_TYPE = z.enum(RELATIONSHIP_KEY_TYPE_ENUM);
export type RELATIONSHIP_KEY_TYPE = z.infer<typeof RELATIONSHIP_KEY_TYPE>;

export const RELATIONSHIP_VALUE_TYPE_ENUM = ["배우자", "자녀"] as const;
export const RELATIONSHIP_VALUE_TYPE = z.enum(RELATIONSHIP_VALUE_TYPE_ENUM);
export type RELATIONSHIP_VALUE_TYPE = z.infer<typeof RELATIONSHIP_VALUE_TYPE>;

export const RELATIONSHIP: Record<RELATIONSHIP_KEY_TYPE, RELATIONSHIP_VALUE_TYPE> = {
	SPOUSE: "배우자",
	CHILD: "자녀"
} as const;

/**
 * @name 성별
 * MALE, FEMALE, UNKNOWN
 */
export const GENDER_KEY_TYPE_ENUM = ["MALE", "FEMALE", "UNKNOWN"] as const;
export const GENDER_KEY_TYPE = z.enum(GENDER_KEY_TYPE_ENUM);
export type GENDER_KEY_TYPE = z.infer<typeof GENDER_KEY_TYPE>;

export const GENDER_VALUE_TYPE_ENUM = ["남자", "여자", "미확인"] as const;
export const GENDER_VALUE_TYPE = z.enum(GENDER_VALUE_TYPE_ENUM);
export type GENDER_VALUE_TYPE = z.infer<typeof GENDER_VALUE_TYPE>;

export const GENDER: Record<GENDER_KEY_TYPE, GENDER_VALUE_TYPE> = {
	MALE: "남자",
	FEMALE: "여자",
	UNKNOWN: "미확인"
} as const;

/**
 * @name 성별코드
 * 남(1,3,5,7) /여( 2,4,6,8) / 모름(NONE)
 */
export const GENDER_CODE_KEY_TYPE_ENUM = ["1", "3", "5", "2", "4", "6", "0"] as const;
export const GENDER_CODE_KEY_TYPE = z.enum(GENDER_CODE_KEY_TYPE_ENUM);
export type GENDER_CODE_KEY_TYPE = z.infer<typeof GENDER_CODE_KEY_TYPE>;

export const GENDER_CODE_VALUE_TYPE_ENUM = ["남(1)", "남(3)", "남(5)", "여(2)", "여(4)", "여(6)", "미확인"] as const;
export const GENDER_CODE_VALUE_TYPE = z.enum(GENDER_CODE_VALUE_TYPE_ENUM);
export type GENDER_CODE_VALUE_TYPE = z.infer<typeof GENDER_CODE_VALUE_TYPE>;

export const GENDER_CODE: Record<GENDER_CODE_KEY_TYPE, GENDER_CODE_VALUE_TYPE> = {
	"1": "남(1)",
	"2": "여(2)",
	"3": "남(3)",
	"4": "여(4)",
	"5": "남(5)",
	"6": "여(6)",
	"0": "미확인"
} as const;

/**
 * @name 달력타입(음력, 양력)
 * SOLAR, LUNAR, UNKNOWN
 */
export const CALENDAR_KEY_TYPE_ENUM = ["LUNAR", "SOLAR", "UNKNOWN"] as const;
export const CALENDAR_KEY_TYPE = z.enum(CALENDAR_KEY_TYPE_ENUM);
export type CALENDAR_KEY_TYPE = z.infer<typeof CALENDAR_KEY_TYPE>;

export const CALENDAR_VALUE_TYPE_ENUM = ["음력", "양력", "알수없음"] as const;
export const CALENDAR_VALUE_TYPE = z.enum(CALENDAR_VALUE_TYPE_ENUM);
export type CALENDAR_VALUE_TYPE = z.infer<typeof CALENDAR_VALUE_TYPE>;

export const CALENDAR: Record<CALENDAR_KEY_TYPE, CALENDAR_VALUE_TYPE> = {
	LUNAR: "음력",
	SOLAR: "양력",
	UNKNOWN: "알수없음"
} as const;

/**
 * @name 종교
 * CHRISTIANITY, CATHOLICISM, BUDDHISM, CONFUCIANISM, NONE, ETC, UNKNOWN
 */
export const RELIGION_KEY_TYPE_ENUM = [
	"CHRISTIANITY",
	"CATHOLICISM",
	"BUDDHISM",
	"CONFUCIANISM",
	"NONE",
	"ETC",
	"UNKNOWN"
] as const;
export const RELIGION_KEY_TYPE = z.enum(RELIGION_KEY_TYPE_ENUM);
export type RELIGION_KEY_TYPE = z.infer<typeof RELIGION_KEY_TYPE>;

export const RELIGION_VALUE_TYPE_ENUM = ["기독교", "천주교", "불교", "유교", "무교", "기타", "알수없음"] as const;
export const RELIGION_VALUE_TYPE = z.enum(RELIGION_VALUE_TYPE_ENUM);
export type RELIGION_VALUE_TYPE = z.infer<typeof RELIGION_VALUE_TYPE>;

export const RELIGION: Record<RELIGION_KEY_TYPE, RELIGION_VALUE_TYPE> = {
	CHRISTIANITY: "기독교",
	CATHOLICISM: "천주교",
	BUDDHISM: "불교",
	CONFUCIANISM: "유교",
	NONE: "무교",
	ETC: "기타",
	UNKNOWN: "기타"
} as const;

/**
 * @name 혈액형
 * A, B, AB, O, UNKNOWN
 */
export const BLOOD_KEY_TYPE_ENUM = ["A", "B", "O", "AB", "UNKNOWN"] as const;
export const BLOOD_KEY_TYPE = z.enum(BLOOD_KEY_TYPE_ENUM);
export type BLOOD_KEY_TYPE = z.infer<typeof BLOOD_KEY_TYPE>;

export const BLOOD_VALUE_TYPE_ENUM = ["A", "B", "O", "AB", "알수없음"] as const;
export const BLOOD_VALUE_TYPE = z.enum(BLOOD_VALUE_TYPE_ENUM);
export type BLOOD_VALUE_TYPE = z.infer<typeof BLOOD_VALUE_TYPE>;

export const BLOOD: Record<BLOOD_KEY_TYPE, BLOOD_VALUE_TYPE> = {
	A: "A",
	B: "B",
	O: "O",
	AB: "AB",
	UNKNOWN: "알수없음"
} as const;

/**
 * @name 선호도(상/중/하)
 * GOOD, PAIR, POOR, UNKNOWN
 */
export const PREFERENCE_KEY_TYPE_ENUM = ["GOOD", "PAIR", "POOR", "UNKNOWN"] as const;
export const PREFERENCE_KEY_TYPE = z.enum(PREFERENCE_KEY_TYPE_ENUM);
export type PREFERENCE_KEY_TYPE = z.infer<typeof PREFERENCE_KEY_TYPE>;

export const PREFERENCE_VALUE_TYPE_ENUM = ["상", "중", "하", "알수없음"] as const;
export const PREFERENCE_VALUE_TYPE = z.enum(PREFERENCE_VALUE_TYPE_ENUM);
export type PREFERENCE_VALUE_TYPE = z.infer<typeof PREFERENCE_VALUE_TYPE>;

export const PREFERENCE: Record<PREFERENCE_KEY_TYPE, PREFERENCE_VALUE_TYPE> = {
	GOOD: "상",
	PAIR: "중",
	POOR: "하",
	UNKNOWN: "알수없음"
} as const;

/**
 * @name 띠(십이지신)
 * RAT, OX, TIGER, RABBIT, DRAGON, SNAKE, HORSE, SHEEP, MONKEY, ROOSTER, DOG, PIG, UNKNOWN
 */
export const CHINESE_ZODIAC_SYMBOLS_KEY_TYPE_ENUM = [
	"RAT",
	"OX",
	"TIGER",
	"RABBIT",
	"DRAGON",
	"SNAKE",
	"HORSE",
	"SHEEP",
	"MONKEY",
	"ROOSTER",
	"DOG",
	"PIG",
	"UNKNOWN"
] as const;
export const CHINESE_ZODIAC_SYMBOLS_KEY_TYPE = z.enum(CHINESE_ZODIAC_SYMBOLS_KEY_TYPE_ENUM);
export type CHINESE_ZODIAC_SYMBOLS_KEY_TYPE = z.infer<typeof CHINESE_ZODIAC_SYMBOLS_KEY_TYPE>;

export const CHINESE_ZODIAC_SYMBOLS_VALUE_TYPE_ENUM = [
	"쥐",
	"소",
	"호랑이",
	"토끼",
	"용",
	"뱀",
	"말",
	"양",
	"원숭이",
	"닭",
	"개",
	"돼지",
	"알수없음"
] as const;
export const CHINESE_ZODIAC_SYMBOLS_VALUE_TYPE = z.enum(CHINESE_ZODIAC_SYMBOLS_VALUE_TYPE_ENUM);
export type CHINESE_ZODIAC_SYMBOLS_VALUE_TYPE = z.infer<typeof CHINESE_ZODIAC_SYMBOLS_VALUE_TYPE>;

export const CHINESE_ZODIAC_SYMBOLS: Record<CHINESE_ZODIAC_SYMBOLS_KEY_TYPE, CHINESE_ZODIAC_SYMBOLS_VALUE_TYPE> = {
	RAT: "쥐",
	OX: "소",
	TIGER: "호랑이",
	RABBIT: "토끼",
	DRAGON: "용",
	SNAKE: "뱀",
	HORSE: "말",
	SHEEP: "양",
	MONKEY: "원숭이",
	ROOSTER: "닭",
	DOG: "개",
	PIG: "돼지",
	UNKNOWN: "알수없음"
} as const;

/**
 * @name 자격 - certificates
 * CPA(공인회계사), LAWYER(변호사), REAL_ESTATE_AGENT(공인중개사), APPRAISER(감정평가사)
 * TAX_ACCOUNTANT, LAWYER, REAL_ESTATE_AGENT, CPA, APPRAISER, AICPA, EA
 * 노무사(CERTIFIED_LABOR_ATTORNEY), 법무사(JUDICIAL_SCRIVENER) , 변리사(PATENT_ATTORNEY)
 */
export const CERTIFICATES_KEY_TYPE_ENUM = [
	"CPA",
	"LAWYER",
	"APPRAISER",
	"CERTIFIED_LABOR_ATTORNEY",
	"JUDICIAL_SCRIVENER",
	"PATENT_ATTORNEY"
] as const;
export const CERTIFICATES_KEY_TYPE = z.enum(CERTIFICATES_KEY_TYPE_ENUM);
export type CERTIFICATES_KEY_TYPE = z.infer<typeof CERTIFICATES_KEY_TYPE>;

export const CERTIFICATES_VALUE_TYPE_ENUM = [
	"공인회계사",
	"변호사",
	"감정평가사",
	"노무사",
	"법무사",
	"변리사"
] as const;
export const CERTIFICATES_VALUE_TYPE = z.enum(CERTIFICATES_VALUE_TYPE_ENUM);
export type CERTIFICATES_VALUE_TYPE = z.infer<typeof CERTIFICATES_VALUE_TYPE>;

export const CERTIFICATES: Record<CERTIFICATES_KEY_TYPE, CERTIFICATES_VALUE_TYPE> = {
	CPA: "공인회계사",
	LAWYER: "변호사",
	// REAL_ESTATE_AGENT: "공인중개사",
	APPRAISER: "감정평가사",
	CERTIFIED_LABOR_ATTORNEY: "노무사",
	JUDICIAL_SCRIVENER: "법무사",
	PATENT_ATTORNEY: "변리사"
} as const;

/**
 * @name FC보유자격 - fcCertificate
 * LIFE_INSURANCE (생명보험),  PROPERTY_INSURANCE (손해보험), THIRD_INSURANCE(제3보험)
, RETIREMENT_PENSION_INSURANCE (퇴직연금보험), VARIABLE_INSURANCE (변액보험)
 */
export const FC_CERTIFICATES_KEY_TYPE_ENUM = [
	"LIFE_INSURANCE",
	"PROPERTY_INSURANCE",
	"THIRD_INSURANCE",
	"RETIREMENT_PENSION_INSURANCE",
	"VARIABLE_INSURANCE"
] as const;
export const FC_CERTIFICATES_KEY_TYPE = z.enum(FC_CERTIFICATES_KEY_TYPE_ENUM);
export type FC_CERTIFICATES_KEY_TYPE = z.infer<typeof FC_CERTIFICATES_KEY_TYPE>;

export const FC_CERTIFICATES_VALUE_TYPE_ENUM = ["생명보험", "손해보험", "제3보험", "퇴직연금보험", "변액보험"] as const;
export const FC_CERTIFICATES_VALUE_TYPE = z.enum(FC_CERTIFICATES_VALUE_TYPE_ENUM);
export type FC_CERTIFICATES_VALUE_TYPE = z.infer<typeof FC_CERTIFICATES_VALUE_TYPE>;

export const FC_CERTIFICATES: Record<FC_CERTIFICATES_KEY_TYPE, FC_CERTIFICATES_VALUE_TYPE> = {
	LIFE_INSURANCE: "생명보험",
	PROPERTY_INSURANCE: "손해보험",
	THIRD_INSURANCE: "제3보험",
	RETIREMENT_PENSION_INSURANCE: "퇴직연금보험",
	VARIABLE_INSURANCE: "변액보험"
} as const;

/**
 * @name 경력 - careerType
 * NTS, TAX_TRIBUNAL, TAX_SOCIETY, TAX_CORPORATION
 * 국세청, 조세심판원, 세무사회, 세무법인
 */
export const CAREER_KEY_TYPE_ENUM = ["NTS", "TAX_TRIBUNAL", "TAX_SOCIETY", "TAX_CORPORATION"] as const;
export const CAREER_KEY_TYPE = z.enum(CAREER_KEY_TYPE_ENUM);
export type CAREER_KEY_TYPE = z.infer<typeof CAREER_KEY_TYPE>;

export const CAREER_VALUE_TYPE_ENUM = ["국세청", "조세심판원", "세무사회", "세무법인"] as const;
export const CAREER_VALUE_TYPE = z.enum(CAREER_VALUE_TYPE_ENUM);
export type CAREER_VALUE_TYPE = z.infer<typeof CAREER_VALUE_TYPE>;

export const CAREER: Record<CAREER_KEY_TYPE, CAREER_VALUE_TYPE> = {
	NTS: "국세청",
	TAX_TRIBUNAL: "조세심판원",
	TAX_SOCIETY: "세무사회",
	TAX_CORPORATION: "세무법인"
} as const;

/**
 * @name 상태(companyStatus)
 * REGISTERED(등록), RE_REGISTERED(재등록), MANAGEMENT(관리), WITHDRAWN(말소), UNKNOWN(알수없음)
 */
export const COMPANY_STATUS_KEY_TYPE_ENUM = [
	"REGISTERED",
	"RE_REGISTERED",
	"MANAGEMENT",
	"WITHDRAWN",
	"UNKNOWN"
] as const;
export const COMPANY_STATUS_KEY_TYPE = z.enum(COMPANY_STATUS_KEY_TYPE_ENUM);
export type COMPANY_STATUS_KEY_TYPE = z.infer<typeof COMPANY_STATUS_KEY_TYPE>;

export const COMPANY_STATUS_VALUE_TYPE_ENUM = ["등록", "재등록", "관리", "말소", "알수없음"] as const;
export const COMPANY_STATUS_VALUE_TYPE = z.enum(COMPANY_STATUS_VALUE_TYPE_ENUM);
export type COMPANY_STATUS_VALUE_TYPE = z.infer<typeof COMPANY_STATUS_VALUE_TYPE>;

export const COMPANY_STATUS: Record<COMPANY_STATUS_KEY_TYPE, COMPANY_STATUS_VALUE_TYPE> = {
	REGISTERED: "등록",
	RE_REGISTERED: "재등록",
	MANAGEMENT: "관리",
	WITHDRAWN: "말소",
	UNKNOWN: "알수없음"
} as const;

/**
 * @name 상담 상태
 */
export const CONSULTATION_KEY_TYPE_ENUM = ["VISIT_AND_COUNSEL", "VISIT", "ETC"] as const;
export const CONSULTATION_KEY_TYPE = z.enum(CONSULTATION_KEY_TYPE_ENUM);
export type CONSULTATION_KEY_TYPE = z.infer<typeof CONSULTATION_KEY_TYPE>;

export const CONSULTATION_VALUE_TYPE_ENUM = ["방문 및 상담", "단순방문", "기타"] as const;
export const CONSULTATION_VALUE_TYPE = z.enum(CONSULTATION_VALUE_TYPE_ENUM);
export type CONSULTATION_VALUE_TYPE = z.infer<typeof CONSULTATION_VALUE_TYPE>;

export const CONSULTATION: Record<CONSULTATION_KEY_TYPE, CONSULTATION_VALUE_TYPE> = {
	VISIT_AND_COUNSEL: "방문 및 상담",
	VISIT: "단순방문",
	ETC: "기타"
} as const;

/**
 * @name 상담 구분
 */
export const CONSULTATION_TARGET_KEY_TYPE_ENUM = [
	"POTENTIAL_CUSTOMER_INTRODUCE",
	"TAX_ACCOUNTANT_RECOMMENDATION",
	"ETC_VISIT"
] as const;
export const CONSULTATION_TARGET_KEY_TYPE = z.enum(CONSULTATION_TARGET_KEY_TYPE_ENUM);
export type CONSULTATION_TARGET_KEY_TYPE = z.infer<typeof CONSULTATION_TARGET_KEY_TYPE>;

export const CONSULTATION_TARGET_VALUE_TYPE_ENUM = ["가망고객 소개", "세무사 추천", "기타 방문"] as const;
export const CONSULTATION_TARGET_VALUE_TYPE = z.enum(CONSULTATION_TARGET_VALUE_TYPE_ENUM);
export type CONSULTATION_TARGET_VALUE_TYPE = z.infer<typeof CONSULTATION_TARGET_VALUE_TYPE>;

export const CONSULTATION_TARGET: Record<CONSULTATION_TARGET_KEY_TYPE, CONSULTATION_TARGET_VALUE_TYPE> = {
	POTENTIAL_CUSTOMER_INTRODUCE: "가망고객 소개",
	TAX_ACCOUNTANT_RECOMMENDATION: "세무사 추천",
	ETC_VISIT: "기타 방문"
} as const;

/**
 * @name 고객(CUSTOMER) 구분
 * INDIVIDUAL("개인"), CORPORATION("법인"), UNKNOWN("알수없음")
 */
export const CUSTOMER_KEY_TYPE_ENUM = ["INDIVIDUAL", "CORPORATION", "UNKNOWN"] as const;
export const CUSTOMER_KEY_TYPE = z.enum(CUSTOMER_KEY_TYPE_ENUM);
export type CUSTOMER_KEY_TYPE = z.infer<typeof CUSTOMER_KEY_TYPE>;

export const CUSTOMER_VALUE_TYPE_ENUM = ["개인", "법인", "알수없음"] as const;
export const CUSTOMER_VALUE_TYPE = z.enum(CUSTOMER_VALUE_TYPE_ENUM);
export type CUSTOMER_VALUE_TYPE = z.infer<typeof CUSTOMER_VALUE_TYPE>;

export const CUSTOMER: Record<CUSTOMER_KEY_TYPE, CUSTOMER_VALUE_TYPE> = {
	INDIVIDUAL: "개인",
	CORPORATION: "법인",
	UNKNOWN: "알수없음"
} as const;

/**
 * @name 취미(HOBBY) 구분
 * 등산, 낚시, 자전거, 탁구, 테니스, 당구, 바둑
 */
export const HOBBY_KEY_TYPE_ENUM = [
	"HIKING",
	"FISHING",
	"CYCLING",
	"TENNIS",
	"BILLIARDS",
	"BADUK",
	"MARATHON",
	"NO_HOBBY"
] as const;
export const HOBBY_KEY_TYPE = z.enum(HOBBY_KEY_TYPE_ENUM);
export type HOBBY_KEY_TYPE = z.infer<typeof HOBBY_KEY_TYPE>;

export const HOBBY_VALUE_TYPE_ENUM = ["등산", "낚시", "자전거", "탁구", "당구", "바둑", "마라톤", "취미없음"] as const;
export const HOBBY_VALUE_TYPE = z.enum(HOBBY_VALUE_TYPE_ENUM);
export type HOBBY_VALUE_TYPE = z.infer<typeof HOBBY_VALUE_TYPE>;

export const HOBBY: Record<HOBBY_KEY_TYPE, HOBBY_VALUE_TYPE> = {
	HIKING: "등산",
	FISHING: "낚시",
	CYCLING: "자전거",
	TENNIS: "탁구",
	BILLIARDS: "당구",
	BADUK: "바둑",
	MARATHON: "마라톤",
	NO_HOBBY: "취미없음"
} as const;

/**
 * @name 고객타입
 * INDIVIDUAL, CORPORATION, UNKNOWN
 */
export const RECOMMENDED_CUSTOMER_KEY_TYPE_ENUM = ["INDIVIDUAL", "CORPORATION", "UNKNOWN"] as const;
export const RECOMMENDED_CUSTOMER_KEY_TYPE = z.enum(RECOMMENDED_CUSTOMER_KEY_TYPE_ENUM);
export type RECOMMENDED_CUSTOMER_KEY_TYPE = z.infer<typeof RECOMMENDED_CUSTOMER_KEY_TYPE>;

export const RECOMMENDED_CUSTOMER_VALUE_ENUM = ["개인", "법인", "알수없음"] as const;
export const RECOMMENDED_CUSTOMER_VALUE_TYPE = z.enum(RECOMMENDED_CUSTOMER_VALUE_ENUM);
export type RECOMMENDED_CUSTOMER_VALUE_TYPE = z.infer<typeof RECOMMENDED_CUSTOMER_VALUE_TYPE>;

export const RECOMMENDED_CUSTOMER: Record<RECOMMENDED_CUSTOMER_KEY_TYPE, RECOMMENDED_CUSTOMER_VALUE_TYPE> = {
	INDIVIDUAL: "개인",
	CORPORATION: "법인",
	UNKNOWN: "알수없음"
} as const;

/**
 * @name 고객구분(고객/법인/알수없음)
 * INDIVIDUAL, CORPORATION, UNKNOWN
 */
export const CUSTOMER_TYPE_KEY_TYPE_ENUM = ["INDIVIDUAL", "CORPORATION", "UNKNOWN"] as const;
export const CUSTOMER_TYPE_KEY_TYPE = z.enum(CUSTOMER_TYPE_KEY_TYPE_ENUM);
export type CUSTOMER_TYPE_KEY_TYPE = z.infer<typeof CUSTOMER_TYPE_KEY_TYPE>;

export const CUSTOMER_TYPE_VALUE_TYPE_ENUM = ["개인", "법인", "알수없음"] as const;
export const CUSTOMER_TYPE_VALUE_TYPE = z.enum(CUSTOMER_TYPE_VALUE_TYPE_ENUM);
export type CUSTOMER_TYPE_VALUE_TYPE = z.infer<typeof CUSTOMER_TYPE_VALUE_TYPE>;

export const CUSTOMER_TYPE: Record<CUSTOMER_TYPE_KEY_TYPE, CUSTOMER_TYPE_VALUE_TYPE> = {
	INDIVIDUAL: "개인",
	CORPORATION: "법인",
	UNKNOWN: "알수없음"
} as const;

/**
 * @name 소개자 구분(세무사, TP, 지인, 기타, 본인)
 * TAX_ACCOUNTANT, TP, ACQUAINTANCE, ETC, MYSELF
 */
export const INTRODUCER_KEY_TYPE_ENUM = ["TAX_ACCOUNTANT", "TP", "ACQUAINTANCE", "ETC", "MYSELF"] as const;
export const INTRODUCER_KEY_TYPE = z.enum(INTRODUCER_KEY_TYPE_ENUM);
export type INTRODUCER_KEY_TYPE = z.infer<typeof INTRODUCER_KEY_TYPE>;

export const INTRODUCER_VALUE_TYPE_ENUM = ["세무사", "TP", "지인", "기타", "본인"] as const;
export const INTRODUCER_VALUE_TYPE = z.enum(INTRODUCER_VALUE_TYPE_ENUM);
export type INTRODUCER_VALUE_TYPE = z.infer<typeof INTRODUCER_VALUE_TYPE>;

export const INTRODUCER: Record<INTRODUCER_KEY_TYPE, INTRODUCER_VALUE_TYPE> = {
	TAX_ACCOUNTANT: "세무사",
	TP: "TP",
	ACQUAINTANCE: "지인",
	ETC: "기타",
	MYSELF: "본인"
} as const;



/**
 * @name 등록 상태 구분(대기, 승인, 반려 )
 * PENDING, APPROVED, REJECTED
 */
export const REGISTER_STATUS_KEY_TYPE_ENUM = ["PENDING", "APPROVED", "REJECTED"] as const;
export const REGISTER_STATUS_KEY_TYPE = z.enum(REGISTER_STATUS_KEY_TYPE_ENUM);
export type REGISTER_STATUS_KEY_TYPE = z.infer<typeof REGISTER_STATUS_KEY_TYPE>;

export const REGISTER_STATUS_VALUE_TYPE_ENUM = ["대기", "승인", "반려"] as const;
export const REGISTER_STATUS_VALUE_TYPE = z.enum(REGISTER_STATUS_VALUE_TYPE_ENUM);
export type REGISTER_STATUS_VALUE_TYPE = z.infer<typeof REGISTER_STATUS_VALUE_TYPE>;

export const REGISTER_STATUS: Record<REGISTER_STATUS_KEY_TYPE, REGISTER_STATUS_VALUE_TYPE> = {
	PENDING: "대기",
	APPROVED: "승인",
	REJECTED: "반려",
} as const;
